import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Tag } from "@phosphor-icons/react";

const formatCode = (value, prev) => {
  let raw = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
  if (value.length < prev.length && prev.endsWith("-") && raw.length === 4) raw = raw.slice(0, 3);
  return raw.length >= 4 ? `${raw.slice(0, 4)}-${raw.slice(4)}` : raw;
};

export const CodeSearchForm = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const raw = code.replace(/[^A-Z0-9]/g, "");
    if (raw.length !== 8) {
      setError("Le code doit contenir 8 caractères (ex. AB3X-K9MZ).");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get(`/public/doudou-by-code/${raw}`);
      navigate(`/scan/${data.doudou_id}`);
    } catch (err) {
      setError(err.response?.data?.detail || "Aucun doudou ne correspond à ce code, vérifiez l'étiquette.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-br from-orange-50 to-rose-50 rounded-3xl border border-orange-200 p-6 sm:p-8" data-testid="code-search">
      <p className="font-display font-bold text-lg text-stone-800 flex items-center gap-2">
        <Tag size={22} weight="duotone" className="text-orange-500" /> Le doudou a une étiquette Doudou Alert ?
      </p>
      <p className="text-sm text-stone-600 mt-1">Saisissez le code inscrit dessus : la famille sera prévenue directement.</p>
      <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-3" data-testid="code-search-form">
        <input
          type="text"
          maxLength={9}
          autoCapitalize="characters"
          autoComplete="off"
          aria-label="Code de l'étiquette"
          placeholder="Ex. AB3X-K9MZ"
          value={code}
          onChange={(e) => setCode(formatCode(e.target.value, code))}
          className="flex-1 min-w-0 rounded-full border-2 border-orange-200 bg-white px-5 py-3 text-lg font-mono font-bold tracking-widest text-center uppercase focus:outline-none focus:border-orange-400"
          data-testid="code-search-input"
        />
        <Button type="submit" disabled={loading} className="bg-rose-500 hover:bg-rose-600 rounded-full px-6 py-6 font-bold shadow shadow-rose-500/20" data-testid="code-search-submit">
          {loading ? "Recherche..." : "Trouver ce doudou"}
        </Button>
      </form>
      {error && <p className="mt-3 text-sm text-rose-600" data-testid="code-search-error">{error} Vous pouvez remplir le formulaire ci-dessous.</p>}
    </div>
  );
};

export default CodeSearchForm;
